import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const header = css`
  margin-bottom: ${size[32]};
`

export const title = css`
  margin-bottom: ${size[4]};
`

export const multiplication = (theme: Theme) => css`
  color: ${theme.palette.neutral[700]};
`

export const buttonContainer = css`
  padding-top: ${size[40]};
  padding-bottom: ${size[40]};

  ${breakpoint.up('sm')} {
    padding-top: ${size[64]};
    padding-bottom: ${size[64]};
  }
`

export const termsContainer = css`
  padding-top: ${size[32]};
  padding-bottom: ${size[32]};

  ${breakpoint.up('sm')} {
    padding-top: ${size[48]};
    padding-bottom: ${size[48]};
  }
`
